// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".url-popover .components-popover__content .components-panel__body .container .components-base-control {\n  min-width: 250px;\n}\n.url-popover .components-popover__content .components-panel__body .container .components-base-control:not(:first-child) {\n  margin-top: 15px;\n}", ""]);
// Exports
module.exports = exports;
